module.exports = ['$urlRouterProvider', '$stateProvider', '$provide', 'ngMetaProvider', 'settings', '$httpProvider', 'sriClientConfigurationProvider',
  function ($urlRouterProvider, $stateProvider, $provide, ngMetaProvider, settings, $httpProvider, sriClientConfigurationProvider) {
    'use strict';

    sriClientConfigurationProvider.set({raw: false, baseUrl: settings.apisAndUrls.api});

    // States
    require('./routes')($stateProvider, $urlRouterProvider);

    // Meta Tags
    ngMetaProvider.setDefaultTitle('Leerplansite');
    ngMetaProvider.setDefaultTag('author', 'Katholiek Onderwijs Vlaanderen');
    ngMetaProvider.setDefaultTag('keywords', 'Katholiek Onderwijs Vlaanderen, Basisonderwijs, Leerplanconcept, Ordeningskader, ZILL, Leerplansite');
    ngMetaProvider.setDefaultTag('description', 'ZILL Leerplansite');
    ngMetaProvider.setDefaultTag('applicationName', 'ZILL Leerplansite');
    ngMetaProvider.setDefaultTag('image', 'https://zill.katholiekonderwijs.vlaanderen/dist/images/home_01.jpg');
    ngMetaProvider.useTitleSuffix(true);
    ngMetaProvider.setDefaultTitleSuffix(' | ZILL');

    // Google Analytics
    if (settings.googlAnalytics.enabled) {
      const tagManagerScript = document.createElement('script');
      tagManagerScript.async = true;
      tagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${settings.googlAnalytics.token}`;
      document.head.appendChild(tagManagerScript);

      const analyticsSetupScript = document.createElement('script');
      analyticsSetupScript.innerText = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag(\'js\', new Date()); gtag(\'config\', \'${settings.googlAnalytics.token}\', {send_page_view: false});`;
      document.head.appendChild(analyticsSetupScript);
    }

    // Error Logging
    $provide.decorator('$exceptionHandler', ['$delegate', function ($delegate) {
      return function (exception, cause) {
        console.error(exception); // eslint-disable-line
        // $delegate(exception, cause);
      };
    }]);

    // Set release header on requests
    $provide.factory('VskoReleaseInterceptor', ['$q', '$location', function ($q, $location) {
      return {
        request: function (config) {
          if (config.url.indexOf(settings.apisAndUrls.api) === -1 && config.url.indexOf(settings.apisAndUrls.cachedApi) === -1) {
            config.headers['VSKO-Release'] = settings.release;
          }
          return config;
        }
      };
    }]);
    $httpProvider.interceptors.push('VskoReleaseInterceptor');

  }
];



// WEBPACK FOOTER //
// ./web/js/app/config.js